import React from 'react'
import Badge from "@material-ui/core/Badge";
import NotificationsIcon from "@material-ui/icons/Notifications";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import Api from "../helpers/Api";
import Env from "../config/env";
import Session from "../helpers/Session";

class Notifications extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            openModal: false,
            currentTarget: null,
            notificationsList: [],
        };

    }

    getNotifications = async () => {
        const user = Session.getLogin()
        const data = await Api.get(`${Env.UrlSeguridad}/getCtasMensajesNew/${user.terceroID}`);
        if (data.cod === '1') {
            this.setState({
                notificationsList: data.cta,
            });
        }
    }

    handleOnClick = async (e) => {

        this.setState({
            currentTarget: e.currentTarget
        });

        await this.getNotifications();

        this.setState({
            openModal: true,
        });

    };

    handleCloseModal = () => {
        this.setState({openModal: false})
    };

    render() {
        return (
            <span>
                <IconButton id='notify' color="inherit" onClick={this.handleOnClick}>
                    <Badge badgeContent={0} color="secondary">
                        <NotificationsIcon/>
                    </Badge>
                </IconButton>

                <Popover
                    id='popover'
                    open={this.state.openModal}
                    anchorEl={this.state.currentTarget}
                    onClose={this.handleCloseModal}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}>

                    <div>

                        {this.state.notificationsList.map((val, index) => {
                            return (
                                <div key={index}
                                     style={{border: '1px solid #0098DB', margin: '10px', borderRadius: '10px', padding: '10px'}}>
                                    <span
                                        style={{color: '#0098DB'}}><NotificationsIcon/> <b>{val.CUENTA}</b><br/></span>
                                    <span><b>{val.NOMBRE}</b> <br/></span>
                                    <span>{val.DIRECCION} <br/><br/></span>
                                    <table className='custom-table'>
                                        <tbody>
                                        <tr>
                                            <th>Tipo</th>
                                            <th>Mensaje</th>
                                        </tr>
                                        {
                                            val.CtaMsg.map((val2, index2) => {
                                                return (
                                                    <tr key={index2}>
                                                        <td>{val2.TIPO}</td>
                                                        <td>{val2.MENSAJE}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        </tbody>
                                    </table>
                                    <br/>
                                </div>
                            );
                        })}


                    </div>

                  </Popover>

            </span>
        );
    }
}

export default Notifications